import './ErrorPopupTextConfig';
import './WaterMarkTextConfig';
import './AutoplayTextConfig';
import './LoadingScreenTextConfig';
import './PromotionCounterTextConfig';
import './NetPositionTextConfig';
import './BuyFeatureTextConfig';
import './MaxProbabilityTextConfig';